import Config from "../../../core/config/Config";
import ScormController from "../../../scorm/controller/ScormController";
import DebugModel from "../../debug/model/DebugModel";
import PlatformUserService from "../../platform/controller/PlatformUserService";
import UnsupportedSavegameError from "../exception/UnsupportedSavegameError";
import SaveGameModel from "../model/SaveGameModel";
import LocalStorageSavegameStrategy from "./strategies/LocalStorageSavegameStrategy";
import PlatformSavegameStrategy from "./strategies/PlatformSavegameStrategy";
import SavegameStrategy from "./strategies/SavegameStrategy";
import ScormSavegameStrategy from "./strategies/ScormSavegameStrategy";

export default class SaveGameService {
    /**
     * @constructor
     * @param {SaveGameModel} saveGameModel
     * @param {ScormController} scormController
     * @param {PlatformUserService} platformUserService
     * @param {Config} config
     */
    constructor(saveGameModel, scormController, platformUserService, config) {
        this._saveGameModel = saveGameModel;
        this._scormController = scormController;
        this._platformUserService = platformUserService;
        this._config = config;

        /** @type {SavegameStrategy} */
        this._savegameStrategy = this._determineSavegameStrategy();
    }

    _determineSavegameStrategy() {
        if (this._scormController.isActive()) {
            return new ScormSavegameStrategy(this._saveGameModel, this._scormController);
        }

        const mockPlatformIntegration = this._config.getValue("platform.mockPlatformIntegration");
        if (mockPlatformIntegration) {
            return new LocalStorageSavegameStrategy(this._saveGameModel);
        }

        return new PlatformSavegameStrategy(this._saveGameModel, this._platformUserService);
    }

    async clear() {
        console.warn(`[SaveGameService] Clearing save game with strategy: '${this._savegameStrategy.constructor.name}'`);

        this._saveGameModel.reset();
        await this._savegameStrategy.clear();
    }

    async load() {
        console.log(`[SaveGameService] Attempting to load savegame with strategy: '${this._savegameStrategy.constructor.name}'`);

        await this._savegameStrategy.load();

        // Check if loaded savegame is supported, if not - clear savegame and start fresh.
        if (!this._saveGameModel.versionIsSupported()) {
            throw new UnsupportedSavegameError(`Savegame version ${this._saveGameModel.version} is not supported by this game version. Current game version: ${SaveGameModel.CURRENT_SAVE_GAME_VERSION}.`);
        }
    }

    async save(showFeedback = true) {
        console.log(`[SaveGameService] Attempting to save savegame with strategy: '${this._savegameStrategy.constructor.name}'`);

        if (DebugModel.dontSave) {
            console.warn("[SaveGameService] Not saving because of the 'dontSave' URL parameter.");
            return;
        }

        await this._savegameStrategy.save();

        if (showFeedback) {
            this._saveGameModel.gameSavedFeedbackPending = true;
        }
    }
}